import _Badge from './Badge';

import './style/index.js';

export type { BadgeProps } from './Badge';

export * from './type';

export const Badge = _Badge;
export default Badge;
